import { Progress } from '@eleveo/components-react';
import React from 'react';

export interface ExternalRedirectProps {
  to: string;
}

export const ExternalRedirect: React.FC<ExternalRedirectProps> = ({ to }) => {
  window.location.replace(to);

  return <Progress withOverlay />;
};
